require("@/bootstrap")
require("@/colors")
require("@/datatables")
require("@/globals")
require("@/highcharts")
require("@/login-popup")

import App from "@/components/App.vue"
import VueGoogleMaps from "@fawmi/vue-google-maps"
import { FocusTrap } from "focus-trap-vue"
import { createApp } from "vue"
import { directive } from "vue3-click-away"
import { sentry } from "@/sentry"
import { store } from "@/store"

const app = createApp(App)

app.component("focus-trap", FocusTrap)

app.directive("clickaway", directive)

app.use(store)

app.use(VueGoogleMaps, { load: { key: process.env.MIX_GOOGLE_MAPS_TOKEN } })

$(() => {
  sentry.mount(app)

  app.mount("#app")

  window.$vm = app
})

if (localStorage.theme === "dark" || !("theme" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches) {
  window.user?.is_admin && document.documentElement.classList.add("dark")
} else {
  document.documentElement.classList.remove("dark")
}
